import { mergeWith } from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  booking: {},
  error: '',
  bookingRequestSubmitted: false,
  isFetching: false
};

export default function bookingReducer (state = initialState, action) {
  const { booking, isFetching } = action;
  switch (action.type) {
  case types.BOOKING_FETCH_REQUEST:
  case types.BOOKING_PREPARE_REQUEST:
  case types.BOOKING_CREATE_REQUEST:
    return mergeWith({}, state, {
      isFetching,
      error: ''
    });

  case types.BOOKING_FETCH_SUCCESS:
  case types.BOOKING_PREPARE_SUCCESS:
  case types.BOOKING_CREATE_SUCCESS:
    return {
      ...state,
      booking
    };

  case types.BOOKING_FETCH_FAILURE:
  case types.BOOKING_PREPARE_FAILURE:
  case types.BOOKING_CREATE_FAILURE:
    return mergeWith({}, state, {
      booking
    });

  case types.BOOKING_FORM_SUBMITTED:
    return mergeWith({}, state, {
      bookingRequestSubmitted: true,
      booking
    });

  case types.BOOKING_UPDATE_SUCCESS:
    return mergeWith({}, state, {
      booking
    });

  case types.BOOKING_UPDATE_SHARE_STATE_REQUEST:
    return mergeWith({}, state, {
      isPatching: true
    });

  case types.BOOKING_UPDATE_SHARE_STATE_SUCCESS:
    return mergeWith({}, state, {
      isPatching: false,
      booking: {
        share_state: _.get(action, 'payload.shareState')
      }
    });

  case types.BOOKING_UPDATE_SHARE_STATE_FAILURE:
    return mergeWith({}, state, {
      isPatching: false
    });

  case types.RESET_BOOKING_STORE:
    return initialState;

  default:
    return state;
  }
}
